var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 1.33333C6.96513 1.33333 6.66667 1.03485 6.66667 0.666667C6.66667 0.29848 6.96513 0 7.33333 0H11.3333C11.5101 0 11.6797 0.0702401 11.8047 0.19526C11.9297 0.320287 12 0.489853 12 0.666667V4.66667C12 5.03487 11.7015 5.33333 11.3333 5.33333C10.9651 5.33333 10.6667 5.03487 10.6667 4.66667V2.27615L4.47141 8.4714C4.21105 8.73173 3.78895 8.73173 3.52859 8.4714C3.26825 8.21107 3.26825 7.78893 3.52859 7.5286L9.72387 1.33333H7.33333ZM0 2.66667C0 1.93029 0.596953 1.33333 1.33333 1.33333H4.66667C5.03487 1.33333 5.33333 1.63181 5.33333 2C5.33333 2.36819 5.03487 2.66667 4.66667 2.66667H1.33333V10.6667H9.33333V7.33333C9.33333 6.96513 9.6318 6.66667 10 6.66667C10.3682 6.66667 10.6667 6.96513 10.6667 7.33333V10.6667C10.6667 11.4031 10.0697 12 9.33333 12H1.33333C0.596953 12 0 11.4031 0 10.6667V2.66667Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkGreen);
export default __webpack_public_path__ + "static/media/external-link-green.42b7d9a86be71ba49a67096b00e93842.svg";
export { ForwardRef as ReactComponent };